import { TableQuotation } from "./TableQuotation"
import { TableSalesOrder } from "./TableSalesOrder"
import { TableInvoice } from "./TableInvoice"
import { TableDeposit } from "./TableDeposit"
import { TablePayment } from "./TablePayment"
import { TableReturn } from "./TableReturn"
import { Tab } from "../../../components/ChildItem/components/Item/components/Tabs"
import { useState } from "react"

export const DataTransaction = () => {
  const tabs = ["QUOTATION", "SALES ORDER", "INVOICE", "DEPOSIT", "PAYMENT", "RETURN"]
  const [activeTab, setActiveTab] = useState<number | undefined>(0)

  const renderContent = () => {
    switch (activeTab) {
      case 0: return ( <TableQuotation /> )
      case 1: return ( <TableSalesOrder /> )
      case 2: return ( <TableInvoice /> )
      case 3: return ( <TableDeposit /> )
      case 4: return ( <TablePayment /> )
      case 5: return ( <TableReturn /> )
    }

    return null
  }

  return (
    <div>
      <Tab
        tabs={tabs}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        className="text-[11px]"
      />
      <div className="border-[1px] border-[#3c3c3c] p-3">
        {renderContent()}
      </div>
    </div>
  )
}